import { Component, Inject } from '@angular/core';
import { DocumentData } from '../../../document.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from '../../../dashboard.service';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-edit-observatii-document',
    templateUrl: './edit-observatii-document.component.html',
    styleUrls: ['./edit-observatii-document.component.scss']
})
export class EditObservatiiDocumentComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;

    docData: DocumentData | null = null;

    form: FormGroup = new FormGroup({
        observatii: new FormControl('', [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            docData: DocumentData,
        },
        private dialogRef: MatDialogRef<EditObservatiiDocumentComponent>,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
    ) {
        this.docData = data.docData;
    }

    ngOnInit() {
        if (this.docData) {
            this.form.controls['observatii'].patchValue(this.docData.observatii);
        }
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați acest proces!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.updateDoc();
            }
        });
    }

    updateDoc() {
        this.isLoading = true;

        const payload = {
            ...this.form.value,
        }

        // console.log(payload);
        this.dashboardService
            .updateObservatii(this.docData!.id_document, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: 'Observații documentație actualizate cu succes',
                        icon: 'success',
                        confirmButtonText: this.helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.dialogRef.close({ success: true });
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
